"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMain;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * Main body of the app. There should only be one per application.
 *
 * @category Layout
 */
function UIMain(_ref) {
  var className = _ref.className,
      children = _ref.children,
      flush = _ref.flush,
      use = _ref.use,
      other = (0, _objectWithoutProperties2.default)(_ref, ["className", "children", "flush", "use"]);
  var classes = (0, _classnames.default)('private-main', className, {
    'private-main--flush': flush,
    'private-main--dark': use === 'dark'
  });
  return _react.default.createElement("main", Object.assign({}, other, {
    className: classes
  }), children);
}

UIMain.propTypes = {
  children: _propTypes.default.node.isRequired,
  flush: _propTypes.default.bool,
  use: _propTypes.default.oneOf(['standard', 'dark'])
};
UIMain.displayName = 'UIMain';
module.exports = exports.default;